module.exports = __webpack_public_path__ + "static/hp-advisor.0c483605.webp";